/* bk-warenkorb.js – Warenkorb-Fenster und Versandrechnung (Inhaber 01.11.2026, Vorbild: Handy-Ablauf großer Modehäuser).
   1. window.bkVersand.berechnen(cart): Versandkosten wie Shopify sie rechnet (am 01.11.2026 mit draftOrderCalculate
      nachgemessen): Wellnessprodukte 8,00 €, frei ab 200 € GESAMTEM Warenkorbwert; Saunaholz bis 2,00 m nach Gewicht
      (GLS 24,99 / 49,98 / 74,97 € bis 40 / 80 / 120 kg, darüber Palette 80 €), Bretter über 2,00 m Palette 80 €;
      alles andere versandkostenfrei. Saunaholz ist nie versandkostenfrei. window.bkVersand.html(cart) baut daraus den
      Hinweis mit Fortschrittsbalken. Genutzt von Fenster und templates/cart.liquid.
   2. Warenkorb-Fenster (snippets/warenkorb-fenster.liquid): „In den Warenkorb“ legt per /cart/add.js ab und öffnet
      „Im Warenkorb“ mit Versandhinweis, „Zum Warenkorb“, „Weiter einkaufen“ und „Passt dazu“ – statt auf /cart zu springen.
      Bei einem Fehler bleibt man auf der Seite und sieht die Meldung am Kaufknopf (kein stilles Nachsenden).
   Seite sperren am <html>, nicht am <body> (siehe bk-basis.js). */
(function () {
  'use strict';
  var FREI_AB = 20000, WELLNESS = 800, GLS = 2499, PALETTE = 8000; /* Cent */

  function geld(cent) { return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function bild(url, breite) { if (!url) return ''; var u = url.indexOf('//') === 0 ? 'https:' + url : url; return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite; }
  /* Brettlänge aus dem Variantentitel der Paket-Profilbretter, z. B. "… / 2,30 m" */
  function brettLaenge(i) { var m = /(\d+,\d+)\s*m$/.exec(i.variant_title || ''); return m ? parseFloat(m[1].replace(',', '.')) : 0; }

  function berechnen(cart) {
    var items = cart.items || [], summe = cart.total_price || 0;
    var wellness = false, kurz = [], lang = [];
    items.forEach(function (i) {
      if (i.product_type === 'Wellnessprodukt') wellness = true;
      else if (i.product_type === 'Saunaholz') (brettLaenge(i) > 2 ? lang : kurz).push(i);
    });
    var holz = kurz.length > 0 || lang.length > 0, kosten = 0, teile = [];
    if (wellness && summe < FREI_AB) { kosten += WELLNESS; teile.push('Wellnessprodukte ' + geld(WELLNESS)); }
    if (kurz.length) {
      var kg = kurz.reduce(function (s, i) { return s + (i.grams || 0) * i.quantity; }, 0) / 1000;
      var holzKosten = kg > 120 ? PALETTE : (kg > 80 ? 3 * GLS : (kg > 40 ? 2 * GLS : GLS));
      kosten += holzKosten;
      teile.push(kg > 120 ? 'Saunaholz Palette ' + geld(PALETTE) : 'Saunaholz GLS ' + geld(holzKosten));
    }
    if (lang.length) { kosten += PALETTE; teile.push('Bretter über 2,00 m Palette ' + geld(PALETTE)); }
    return {
      summe: summe, kosten: kosten, teile: teile, wellness: wellness, holz: holz,
      /* „noch X €“ nur, wenn Versand allein an der 200-€-Grenze hängt (Wellness ohne Saunaholz) */
      noch: wellness && !holz && summe < FREI_AB ? FREI_AB - summe : 0,
      frei: kosten === 0 && !holz
    };
  }

  /* Versandhinweis mit Fortschrittsbalken (Fenster und Warenkorb-Seite) */
  function versandHtml(cart) {
    var v = berechnen(cart), anteil = null, text = '', zusatz = '';
    if (v.noch) {
      anteil = v.summe / FREI_AB;
      text = '<span><strong>' + geld(v.noch) + '</strong> bis zum kostenlosen Versand</span><span class="bk-versand__grenze">' + geld(FREI_AB) + '</span>';
      zusatz = 'ansonsten Versandkosten: ' + geld(WELLNESS);
    } else if (v.frei) {
      anteil = 1;
      text = '<span><strong>Versandkostenfrei</strong> innerhalb Deutschlands</span>';
      if (v.wellness) zusatz = 'Wellnessprodukte ab ' + geld(FREI_AB) + ' Bestellwert versandkostenfrei.';
    } else {
      text = '<span>Versandkosten voraussichtlich: <strong>' + geld(v.kosten) + '</strong></span>';
      zusatz = v.teile.join(' · ') + ' – maßgeblich ist der Betrag an der Kasse.';
    }
    return (anteil !== null
      ? '<div class="bk-versand__balken" role="progressbar" aria-label="Fortschritt bis zum kostenlosen Versand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(anteil * 100) + '"><span style="width:' + Math.max(4, Math.round(anteil * 100)) + '%"></span></div>'
      : '') +
      '<p class="bk-versand__text">' + text + '</p>' +
      (zusatz ? '<p class="bk-versand__zusatz">' + esc(zusatz) + '</p>' : '');
  }
  window.bkVersand = { berechnen: berechnen, html: versandHtml, geld: geld, FREI_AB: FREI_AB, WELLNESS: WELLNESS, GLS: GLS };

  /* Zahl am Warenkorb in Kopfleiste und Menü */
  function zaehler(n) { document.querySelectorAll('.bk-cart-count').forEach(function (el) { el.textContent = n > 0 ? n : ''; }); }

  var fenster = document.getElementById('bk-wkf');
  var form = document.getElementById('pd-product-form');
  if (!fenster || !form) return;
  var letzterFokus = null, offen = false, zuTimer = null;

  function versandZeigen(cart) {
    var el = document.getElementById('bk-wkf-versand');
    if (el) el.innerHTML = versandHtml(cart);
  }

  /* Hauptartikel groß, Mitgebuchtes (Aufbau, Anfahrt, Elektroanschluss, Aufpreis-Optionen) als Zeile mit Summe darunter */
  function artikelZeigen(alle) {
    var el = document.getElementById('bk-wkf-artikel');
    if (!el) return;
    var posten = alle.filter(function (p) { return p.product_type !== 'Aufbauservice'; })[0] || alle[0];
    if (!posten) { el.innerHTML = ''; return; }
    var weitere = alle.filter(function (p) { return p !== posten; });
    var weitereHtml = weitere.length
      ? '<div class="bk-wkf__weitere">+ ' + weitere.map(function (p) { return esc(p.product_title); }).join(', ') + ': ' +
        geld(weitere.reduce(function (s, p) { return s + (p.final_line_price || 0); }, 0)) + ' <span class="bk-wkf__mwst">inkl. MwSt.</span></div>'
      : '';
    var variante = posten.variant_title && posten.variant_title !== 'Default Title' ? posten.variant_title : '';
    /* gewählte Angaben wie „Sorte: Alaska“ (Eigenschaften mit _ sind intern) */
    var angaben = Object.keys(posten.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && posten.properties[k]; }).slice(0, 2)
      .map(function (k) { return '<div class="bk-wkf__variante">' + esc(k) + ': ' + esc(posten.properties[k]) + '</div>'; }).join('');
    el.innerHTML = (posten.image ? '<span class="bk-wkf__bild"><img src="' + esc(bild(posten.image, 160)) + '" alt="" width="64" height="64"></span>' : '') +
      '<div class="bk-wkf__artikeltext"><div class="bk-wkf__name">' + esc(posten.product_title) + '</div>' +
      (variante ? '<div class="bk-wkf__variante">' + esc(variante) + '</div>' : '') + angaben +
      '<div class="bk-wkf__preis">' + (posten.quantity > 1 ? posten.quantity + ' × ' : '') + geld(posten.final_price) +
      ' <span class="bk-wkf__mwst">inkl. MwSt.</span></div>' + weitereHtml + '</div>';
  }

  /* „Passt dazu“: was schon im Warenkorb liegt, ausblenden */
  function empfehlungenFiltern(cart) {
    var block = fenster.querySelector('.bk-wkf__empf');
    if (!block) return;
    var im = {};
    (cart.items || []).forEach(function (i) { im[i.handle] = true; });
    var sichtbar = 0;
    block.querySelectorAll('[data-handle]').forEach(function (k) {
      var weg = !!im[k.getAttribute('data-handle')];
      k.hidden = weg;
      if (!weg) sichtbar++;
    });
    block.hidden = sichtbar === 0;
  }

  function sperren(an) {
    var w = document.documentElement;
    w.style.overflow = an ? 'hidden' : '';
    w.style.scrollbarGutter = an ? 'stable' : '';
  }
  function tasten(e) {
    if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
    if (e.key !== 'Tab') return;
    /* Fokus im Fenster halten */
    var f = Array.prototype.filter.call(fenster.querySelectorAll('a[href], button:not([disabled])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var erst = f[0], letzt = f[f.length - 1];
    /* Fokus auf dem Blatt selbst (Klick auf Text) oder außerhalb: zurück ans erste bzw. letzte Element */
    if (f.indexOf(document.activeElement) === -1) { e.preventDefault(); (e.shiftKey ? letzt : erst).focus(); }
    else if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  }
  function oeffnen() {
    clearTimeout(zuTimer);
    if (!offen) {
      /* Der Kaufknopf ist beim Ablegen kurz deaktiviert und verliert dabei den Fokus – dann dorthin zurück */
      var aktiv = document.activeElement;
      letzterFokus = aktiv && aktiv !== document.body ? aktiv : document.getElementById('pd-atc-submit');
      document.addEventListener('keydown', tasten);
    }
    offen = true;
    fenster.hidden = false;
    sperren(true);
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (offen) fenster.classList.add('ist-offen'); }); });
    var zu = fenster.querySelector('.bk-wkf__zu');
    if (zu) zu.focus({ preventScroll: true });
  }
  function schliessen() {
    if (!offen) return;
    offen = false;
    fenster.classList.remove('ist-offen');
    document.removeEventListener('keydown', tasten);
    sperren(false);
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    clearTimeout(zuTimer);
    zuTimer = setTimeout(function () { if (!offen) fenster.hidden = true; }, still ? 0 : 300);
    if (letzterFokus && letzterFokus.focus) letzterFokus.focus({ preventScroll: true });
  }
  fenster.addEventListener('click', function (e) { if (e.target.closest('[data-wkf-zu]')) schliessen(); });

  /* Meldung direkt unter dem Kaufknopf */
  function meldung(text) {
    var el = document.getElementById('pd-wk-meldung');
    var knopf = document.getElementById('pd-atc-submit');
    if (!el) {
      if (!text) return;
      el = document.createElement('p');
      el.id = 'pd-wk-meldung';
      el.className = 'bk-wk-meldung';
      el.setAttribute('role', 'alert');
      if (knopf && knopf.parentNode) knopf.parentNode.insertBefore(el, knopf.nextSibling); else form.appendChild(el);
    }
    el.textContent = text || '';
  }

  /* Legt ab (FormData des Formulars oder {items:[…]} vom Konfigurator) und öffnet das Fenster */
  function absenden(daten) {
    var knopf = document.getElementById('pd-atc-submit');
    var altText = knopf ? knopf.textContent : '', altAus = knopf ? knopf.disabled : false;
    if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird hinzugefügt …'; }
    /* Auswahl während des Ablegens sperren – sonst stellt das Zurücksetzen den Knopf für eine inzwischen ungültige Auswahl wieder frei */
    function sperreForm(an) { if ('inert' in form) form.inert = an; }
    sperreForm(true);
    meldung('');
    var json = !(daten instanceof FormData), abgelegt = false;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: json ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: json ? JSON.stringify(daten) : daten
    })
      .then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; }, function () { if (!r.ok) throw {}; return {}; });
      })
      .then(function (neu) {
        abgelegt = true;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
          .then(function (cart) {
            zaehler(cart.item_count);
            artikelZeigen(neu && neu.items ? neu.items : (neu && neu.id ? [neu] : []));
            versandZeigen(cart);
            empfehlungenFiltern(cart);
            sperreForm(false);
            if (knopf) { knopf.disabled = altAus; knopf.textContent = altText; }
            oeffnen();
          });
      })
      .catch(function (fehler) {
        /* Liegt schon im Warenkorb, nur die Anzeige klappt nicht: zum Warenkorb statt „bitte noch einmal“ (sonst doppelt) */
        if (abgelegt) { location.href = '/cart'; return; }
        sperreForm(false);
        /* Shopifys eigene Fehlertexte kommen teils englisch – deshalb eigene Sätze (422 = nicht oder nicht in der Menge lieferbar) */
        meldung(fehler && fehler.status === 422
          ? 'Dieser Artikel ist in der gewählten Ausführung oder Menge derzeit nicht verfügbar. Gern beraten wir Sie: 06434 9099879.'
          : 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es noch einmal.');
        if (knopf) { knopf.disabled = altAus; knopf.textContent = altText; knopf.focus({ preventScroll: true }); }
      });
  }

  /* Formular abfangen. Der Konfigurator (Aufpreis-Optionen, Aufbau) hat seinen eigenen Abfänger, der vorher läuft,
     selbst preventDefault setzt und absenden() mit allen Positionen aufruft – dann hier nichts tun. */
  form.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    e.preventDefault();
    absenden(new FormData(form));
  });

  /* Zurück aus dem Browser-Speicher (bfcache), etwa nach „Zum Warenkorb“: Fenster zu, Seite frei, Zahl aktuell */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (offen) { schliessen(); clearTimeout(zuTimer); fenster.hidden = true; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) zaehler(cart.item_count); })
      .catch(function () {});
  });

  window.bkWarenkorb = { absenden: absenden, oeffnen: oeffnen, schliessen: schliessen };
})();
